<template>
  <div>
    <div v-if="product.price.price_type === 0">
      <div class="unselect flex-between size-16 full-width" @click="clickSchedule"
           :style="calendarBtnStyle" style="border-radius: 8px">
        <div class="flex-align">
          <i class="material-icons"
             style="font-size: 20px; margin-right: 10px">calendar_today</i>
          <div :style="selectedResvStyle">{{ computedSchedule }}</div>
        </div>
        <i class="material-icons bold" style="font-size: 20px"
           :style="brandColor.primary">keyboard_arrow_right</i>
      </div>
      <!-- 수량 -->
      <div v-if="!product.enable_option">
        <div class="color-sub size-12" style="margin:12px 0 4px 0">수량</div>
        <quantity-input-popup :value.sync="ordered_count"
                              :numberStyle="numberStyle"></quantity-input-popup>
      </div>
      <div v-if="(option1 && option1.length > 0) || (option2 && option2.length > 0)"
           style="padding-bottom: 16px">
        <template v-for="(item1, idx) in option1">
          <lp-dropdown :options="item1.options"
                       style="margin-bottom:12px"
                       placeholder="필수 선택 옵션"
                       @update:ele="res => addEssential(res, item1)"></lp-dropdown>
<!--          <c-input-dropdown v-if="item1.options && item1.options.length !== 0" :key="'key-'+idx"
                            :ref="'essential'+idx"
                            :options="item1.options"
                            @update:value="res => addEssential(res, item1)"
                            @empty="type => emptyOpt(type)"
                            :containerCustomStyle="optionDropdownStyle(idx, option1).container"
                            :dropdownCustomStyle="optionDropdownStyle(idx, option1).dropdown"
                            :dropListCustomStyle="optionDropdownStyle(idx, option1).dropList"
                            :dropItemCustomStyle="optionDropdownStyle(idx, item1).dropItem"
                            :placeholderCustomStyle="optionDropdownStyle(idx, option1).placeholder"
                            :iconCustomStyle="optionDropdownStyle(idx, option1).dropArrowIcon"
                            :labelCustomStyle="optionDropdownStyle(idx, option1).label"
                            :label="`* ${item1.name}`"
                            :placeholder="'옵션 선택하기'"
                            :fullState="essentialState"
                            :fullLength="option1.length"></c-input-dropdown>-->
        </template>
        <div v-if="option2 && option2.length !== 0" style="margin-top:16px;">
          <template v-for="(item2,idx) in option2">
            <lp-dropdown :options="item2.options"
                         placeholder="추가 선택 옵션"
                         @update:ele="res => updateValue(res, item2)"></lp-dropdown>
          </template>
        </div>
        <!-- 선택 된 옵션 수량 -->
        <div style="margin: 32px 0">
          <!-- 필수 옵션 수량 -->
          <template v-for="(item,idx) in optionEss">
            <div v-if="optionEss&&optionEss.length>0" :key="'esskey-'+idx"
                 :style="optQuantityStyle(idx, optionEss)">
              <div class="flex-between" style="margin-bottom: 14px">
                <div class="size-14" style="width: 90%" :style="brandColor.sub">
                  {{ computedName(item) }}</div>
                <i class="material-icons unselect" @click="deleteEss(idx)">close</i>
              </div>
              <div class="flex-between">
                <div class="col-7">
                  <quantity-input v-if="option1[0].maximum>1"
                                  :disabled="true"
                                  :min="item[0].minimum"
                                  :max="item[0].maximum"
                                  :inputStyle="inputCustomStyles()"
                                  :btnMinusStyle="btnMinusCustomStyle(item[0])"
                                  :btnPlusStyle="btnPlusCustomStyle(item[0])"
                                  @update:value="val => computedVal(val,item)"
                                  :disableState="disableState"
                                  :value="item[0].quantity"
                                  :numInput="false"></quantity-input>
                </div>
                <div class="col-5 flex-end">
                  <div class="size-18 weight-500" :style="brandColor.main">
                    +{{ computedEssprice(item) | currencyNum }}<span class="size-16">원</span></div>

                </div>
              </div>
            </div>
          </template>
          <!-- 추가 옵션 수량 -->
          <template v-for="(item2,idx) in optionAdd">
            <div v-if="optionAdd&&optionAdd.length>0" :key="'item2-keys-'+idx"
                 :style="optQuantityStyle(idx, optionAdd)" style="margin-top:16px">
              <div class="flex-between" style="margin-bottom: 14px">
                <div class="size-14" style="width: 90%"
                     :style="brandColor.sub">{{ item2.label }}</div>
                <i class="material-icons unselect" @click="deleteAdd(idx)">close</i>
              </div>
              <div class="flex-between">
                <div class="col-7">
                  <quantity-input v-if="item2.maximum>1"
                                  :disabled="true"
                                  :min="item2.minimum"
                                  :max="item2.maximum"
                                  :inputStyle="inputCustomStyles()"
                                  :btnMinusStyle="btnMinusCustomStyle(item2)"
                                  :btnPlusStyle="btnPlusCustomStyle(item2)"
                                  @update:value="val => computedAdd(val,item2)"
                                  :value="item2.quantity"
                                  :numInput="false"></quantity-input>
                </div>
                <div class="col-5 flex-end">
                  <div class="size-18 weight-500" :style="brandColor.main">
                    +{{ item2.price * item2.quantity | currencyNum }}<span class="size-16">원</span></div>

                </div>
              </div>

            </div>
          </template>
        </div>
      </div>
      <div style="padding-top: 16px" :style="{borderTop: brandBorder.sub.border}" v-if="isBtnEnable">
        <div class="flex-end" >
          <div class="size-14 weight-500" :style="brandColor.sub">총 금액</div>
          <div class="size-28 bold" style="margin-left: 16px"
               :style="brandColor.main">{{ currencyNum(calcPrice) }}<span
            class="size-18 weight-500">원</span></div>
        </div>
      </div>

    </div>
    <div class="flex-end"
         style="margin-top: 16px"
         v-if="product.price.price_type === 0">
      <button class="button" @click="clickBtn" v-if="isBtnEnable">선택하기</button>
    </div>

    <!-- 캘린더 -->
    <div style="position:absolute;top:0;background-color: white;z-index: 10">
      <component :is="scheduleComponent" :productId="product.id"
                 v-show="vSchedule" @selectedResv="onSelectResv" />
    </div>

  </div>
</template>
<script>
  import ScheduleOverlay from "./ScheduleOverlay";
  import SchedulePeriodOverlay from "./SchedulePeriodOverlay";
  import LpDropdown from "../../../../module/common/LpDropdown";
  import QuantityInput from "../../../../module/common/QuantityInput";
  import QuantityInputPopup from "../../../../module/common/QuantityInputPopup";
  export default {
    name: 'BlockResvOption',
    components: {
      QuantityInputPopup,
      QuantityInput, LpDropdown, SchedulePeriodOverlay,
      ScheduleOverlay,
    },
    props: {
      product: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        option1: [],
        option2: [],
        optionAdd: [],
        optionEss: [],
        optionEssId: [],
        disableState: false,
        brandColor: {
          main: {
            color: '#000000'
          },
          brand: {
            color: '#ff5722'
          },
          sub: {
            color: '#bbbbbb'
          }
        },
        brandBgColor: {
          main: {
            backgroundColor: '#ffffff'
          },
          brand: {
            backgroundColor: '#ff5722'
          },
          sub: {
            backgroundColor: '#eeeeee'
          },
          white: {
            backgroundColor: 'white'
          }
        },
        brandBorder: {
          main: {
            border: '1px solid #dddddd'
          },
          brand: {
            border: '1px solid #ff5722'
          },
          primary: {
            border: '1px solid #ff5722'
          },
          sub: {
            border: '1px solid #eeeeee'
          }
        },
        vSchedule: false,
        selectedResv: undefined,
        ordered_count: 1
      }
    },
    created() {

    },
    mounted() {
      this.$nextTick(() => {
        this.setOptions();
      })
    },
    beforeDestroy() {
      // 이동되는 페이지가 주문/결제 페이지가 아닌 경우, 선택했던 날짜 초기화
      if (this.$route.path !== '/order_booking') {
        this.selectedResv = undefined
      }
    },

    methods: {
      onSelectResv(res) {
        this.selectedResv = res;
        this.vSchedule = false;
      },
      setOptions() {
        let opt = this.product.selectors.filter(item => { return item.option_type === 0});
        if (opt.length > 0) {
          for(let i=0; i < opt.length; i++) {
            opt[i].index = i+1;
          }
          opt.forEach(item => {
            this.option1.push(this.setOption(item));
          })

        }
        opt = this.product.selectors.filter(item => { return item.option_type === 1});
        if (opt.length > 0) {
          for(let i=0; i < opt.length; i++) {
            opt[i].index = i+1;
          }
          opt.forEach(item => {
            this.option2.push(this.setOption(item));
          })
        }
      },
      setOption(opt) {
        let option = {
          name: opt.name,
          minimum: opt.minimum,
          maximum: opt.maximum,
          value: undefined,
          options: [],
          option_type: opt.option_type
        };
        if (opt.index) {
          option.index = opt.index;
        }
        opt.options.forEach(item => {
          item.label = `${item.name}: +${this.currency(item.price)}`;
          item.quantity = opt.minimum;
          option.options.push({
            value: item,
            label: item.label,
            type: opt.option_type,
            index: opt.index
          })
        })
        return option;
      },
      computedName(item) {
        let name = '';
        for(let i=0;i<item.length;i++) {
          if(i===0) {
            name = item[i].label
          }
          else name = name + ' X ' + item[i].label;
        }
        return name;
      },
      computedEssprice(item) {
        let price = 0;
        item.forEach(val => {
          price = price + val.price * val.quantity;
        })
        return price;
      },
      computedVal(val, item) {
        let sum = 0;
        let max = this.option1[0].maximum;
        item.forEach(res => {
          res.quantity = val;
        });

        this.optionEss.forEach(ess => {
          sum = sum + ess[0].quantity;
        })
        if(sum<max) {
          this.disableState = false;
        }
        else {
          this.disableState = true;
        }
      },
      computedAdd(val, item) {
        item.quantity = val;
      },
      addEssential(res, opt) {
        console.log('test')
        if(res!==undefined && this.disableState===false) {
          opt.value = this.cloneItem(res);
        }

        let len = 0;
        for(let i=0; i<this.option1.length; i++) {
          if(this.option1[i].value) len++
        }

        if(this.option1.length !== len) return;
        let arr = [];
        let chk = '';
        this.option1.forEach(item => {
          chk += item.value.id + '/';
          arr.push(item.value);
          item.value = undefined;
        })
        if(this.optionEssId.indexOf(chk)===-1) {
          this.optionEssId.push(chk);
          this.optionEss.push(arr);
        }
        else {
          arr = [];
          chk = '';
        }
      },
      updateValue(res, opt) {
        if(res!==undefined) {
          opt.value = this.cloneItem(res);
        }
        let item = find(this.optionAdd, 'id', opt.value.id)
        if(!item) this.optionAdd.push(opt.value);
      },
      emptyOpt(type, val) {
        if(type===0) {
          let arr = [];
          let chk = '';
          this.option1.forEach(item => {
            chk += item.value.id + '/';
            arr.push(item.value);
            item.value = undefined;
          })
          if(this.optionEssId.indexOf(chk)===-1) {
            this.optionEssId.push(chk);
            this.optionEss.push(arr);
          }
          else {
            arr = [];
            chk = '';
          }
        }
        if(type===1) {
          if(this.optionAdd&&this.optionAdd.some(item => item.id === this.option2[val-1].value.id)===false) {
            this.optionAdd.push(this.option2[val-1].value);
          }
          this.option2[val-1].value = undefined;
        }

        this.$store.commit('setEssentialOption', this.optionEss);
        this.$store.commit('setAdditionalOption', this.optionAdd);
      },
      deleteEss(idx) {
        this.optionEss.splice(idx, 1);
        this.optionEssId.splice(idx, 1);
        // this.clickAccount();
      },
      deleteAdd(idx) {
        this.optionAdd.splice(idx, 1);
        // this.clickAccount();
      },
      clickSchedule() {
        this.vSchedule = true;
        // this.$root.$emit('page_modal', 'SchedulePeriodBookingModal')
      },
      clickBtn() {
        if(this.selectedResv === undefined) {
          this.toast('일정을 선택해주세요.');
          return;
        } else if (this.product.is_expired) {
          this.toast('마감된 일정으로는 예약할 수 없습니다.')
          return;
        } else if (!this.isOrderablePeriod) {
          this.toast('해당 일정으로는 예약할 수 없습니다.');
          return;
        } else if (this.option1.length > 0 && this.optionEss.length === 0) {
          this.toast('필수 옵션을 선택해주세요.');
          return;
        }
        if(!this.isBtnEnable) return;
        let resv = this.selectedResv;
        resv.ordered_count = this.ordered_count;
        resv.option1 = this.optionEss;
        resv.option2 = this.optionAdd;
        let param = {};
        // 숙박 예약(기간)
        if(resv.period) {
          param = resv;
          param.product_id = this.product.id;
          if(resv.resv_date !== resv.resv_end_date) {
            param.resvStr = `${resv.resv_date} ~ ${resv.resv_end_date}`;
          } else {
            param.resvStr = resv.resv_date;
          }

        } else {
          param = resv;
          param.product_id = this.product.id;
          // 서비스 예약(단일 시간/날짜)
          let time = '';
          if(resv.all_time) {
            time = '종일';
          } else {
            time = `${resv.start_time} ~ ${resv.end_time}`;
          }
          let param1 = {
            ordered_count: resv.ordered_count,
            date: resv.org_start_date,
            time: time,
            all_time: resv.all_time,
            start_time: resv.start_time,
            end_time: resv.end_time,
            product_id: this.product.id
          };
          Object.assign(param, param1);
          param.resvStr = `${resv.org_start_date} (${time}) `;
        }
        let opt1 = '';
        if(resv.option1 && resv.option1.value) {
          let val = resv.option1.value;
          opt1 = `${val.name} x ${val.quantity}`;
        }
        let opt2 = '';
        if(resv.option2 && resv.option2.value) {
          let val = resv.option2.value;
          opt2= `${val.name} x ${val.quantity}`;
        }
        if(opt1 !== '' && opt2 !== '') {
          param.resvStr += `(${opt1}, ${opt2})`;
        } else if(opt1 !== '') {
          param.resvStr += `(${opt1})`;
        } else if(opt2 !== '') {
          param.resvStr += `(${opt2})`;
        }

        // 금액 적용
        param.order_price = this.calcPrice;
        param.discount_price = this.discountPrice;

        this.$emit('clickReserve', param);
      },
      optionDropdownStyle(idx, option) {
        let deco = {
          container: {
            margin: idx === option.length - 1 ? '0px' : '0 0 16px 0',
          },
          label: {
            color: this.brandColor.sub.color,
            fontSize: '14px',
            lineHeight: '14px',
            margin: '0px 0px 8px'
          },
          dropdown: {
            backgroundColor: this.brandBgColor.white.backgroundColor,
            color: this.brandColor.main.color,
            height: '48px',
            padding: '12px 16px',
            fontSize: '14px',
            borderRadius: '8px',
            border: this.brandBorder.main.border
          },
          dropList: {
            top: '48px',
            borderRadius: '8px',
            boxShadow: '0 2px 16px 0 rgba(0,0,0,0.1)'
          },
          dropItem: {
            backgroundColor: this.brandBgColor.white.backgroundColor,
            color: this.brandColor.main.color,
            padding: '14px 16px'
          },
          dropArrowIcon: {
            position: 'absolute',
            top: '8px',
            right: '8px',
            fontSize: '24px',
            color: this.brandColor.main.color
          },
          placeholder: {
            fontSize: '14px',
            color: this.brandColor.sub.color,
          },
        }
        if (option.options && option.options.length > 0) {
          option.options.forEach((idx, item) => {
            if (idx === option.options.length - 1) {
              deco.dropItem.borderBottom = 'none';
            } else {
              deco.dropItem.borderBottom = this.brandBorder.main.border;
            }
          })
        }
        return deco;
      },
      optQuantityStyle(idx, option) {
        return {
          backgroundColor: '#fafafa',
          marginBottom: idx === option.length - 1 ? '0px' : '16px',
          padding: '16px',
          borderRadius: '8px',
        }
      },
      inputCustomStyles() {
        return {
          width: '40px',
          height: '32px',
          backgroundColor: this.brandBgColor.white.backgroundColor,
          border: this.brandBorder.main.border,
          textAlign: 'center',
          fontSize: '12px',
          color: this.brandColor.main.color,
          fontWeight: '500',
          fontFamily: 'Noto Sans CJK KR'
        }
      },
      btnMinusCustomStyle(op) {
        return {
          backgroundColor: (op && op.minimum === op.quantity) || (op === undefined && op.minimum === op.quantity) ?
            this.brandBgColor.sub.backgroundColor : this.brandBgColor.white.backgroundColor,
          border: this.brandBorder.main.border,
          borderRight: '0px',
          borderRadius: '6px 0 0 6px',
          width: '30px',
          height: '32px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '16px'
        }
      },
      btnPlusCustomStyle(op) {
        return {
          backgroundColor: (op && op.maximum === op.quantity) || (op === undefined && op.maximum === op.quantity) ?
            this.brandBgColor.sub.backgroundColor : this.brandBgColor.white.backgroundColor,
          border: this.brandBorder.main.border,
          borderLeft: '0px',
          borderRadius: '0px 6px 6px 0',
          width: '30px',
          height: '32px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '16px'
        }
      },
      optionsQuantityStyle(op) {
        return {
          input: {
            width: '40px',
            height: '32px',
            backgroundColor: this.brandBgColor.white.backgroundColor,
            border: this.brandBorder.main.border,
            textAlign: 'center',
            fontSize: '12px',
            color: this.brandColor.main.color,
            fontWeight: '500',
            fontFamily: 'Noto Sans CJK KR'
          },
          btnMinus: {
            backgroundColor: (op && op.minimum === op.quantity) || (op === undefined && op.minimum === op.quantity) ?
              this.brandBgColor.sub.backgroundColor : this.brandBgColor.white.backgroundColor,
            border: this.brandBorder.main.border,
            borderRight: '0px',
            borderRadius: '6px 0 0 6px',
            width: '30px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px'
          },
          btnPlus: {
            backgroundColor: (op && op.maximum === op.quantity) || (op === undefined && op.maximum === op.quantity) ?
              this.brandBgColor.sub.backgroundColor : this.brandBgColor.white.backgroundColor,
            border: this.brandBorder.main.border,
            borderLeft: '0px',
            borderRadius: '0px 6px 6px 0',
            width: '30px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px'
          }
        }
      }
    },
    computed: {
      numberStyle() {
        return {
          backgroundColor: '#ffffff',
          padding: '2px 16px',
          borderRadius: '4px'
        }
      },
      calcPrice() {
        let price = this.product.price.price;
        let resv = this.selectedResv;
        let essPrice = 0;
        let addPrice = 0;
        if(resv===undefined && this.discountPrice) {
          return price - this.discountPrice;
        } else if (resv === undefined && !this.discountPrice) {
          return price;
        }
        if (resv === undefined) {
          price = 0;
          return price;
        }
        // 종일 시간대 상품 가격
        if(resv.all_time && this.product.price.all_time) {
          price = this.product.price.all_time_price;
        }

        // if (this.product.sum_price !== 0) {
        //   price = this.product.sum_price;
        // }


        // 옵션가 반영
        if(this.option1.length===0 && this.option2.length===0) {
          price = price * 1;
        }

        if(this.optionEss && this.optionEss.length>0) {
          let originPrice = 0;
          for(let i=0;i<this.optionEss.length;i++) {
            originPrice = originPrice + price - this.discountPrice
            originPrice = originPrice * this.optionEss[i][0].quantity;
            for (let j=0;j<this.optionEss[i].length;j++) {
              essPrice = essPrice + this.optionEss[i][j].price * this.optionEss[i][j].quantity;
            }
          }
          price = (originPrice + essPrice)
          console.log('price', price)
        }
        else {
          // 할인 있을 경우 반영
          price = price - this.discountPrice
          price = price * this.ordered_count
        }

        if(this.optionAdd && this.optionAdd.length>0) {
          for(let i=0;i<this.optionAdd.length;i++) {
            addPrice = addPrice + this.optionAdd[i].price * this.optionAdd[i].quantity;
          }
          price = price + addPrice;
        }

        // 기간이 있을 경우
        if(resv && resv.period && this.product.enable_day_price === false) {
          if(resv.days > 0) {
            price *= resv.days;
          }
        }

        return price;
      },
      discountPrice() {
        let discount_price = 0;
        let has_discount = false;
        if (this.selectedResv) {
          let resv = this.selectedResv;
          // 할인 있을 경우 반영
          if(this.product.price.is_discount) {
            // 시간대 할인
            if(this.product.price.discount_period_type) {
              let start_time = resv.start_time;
              let end_time = resv.end_time;
              let discounts = this.product.discount_time.filter(item => {
                return item.start_time === start_time && item.end_time === end_time;
              }).length;
              if(discounts>0) {
                has_discount = true;
              }
            }
            // 날짜별 할인
            else {
              let resv_date = resv.org_start_date !== undefined ? resv.org_start_date : resv.resv_date;
              // if(resv_date === undefined) {
              //   resv_date = resv.resv_date;
              // }
              let start_date = this.product.price.start_date;
              let end_date = this.product.price.end_date;

              if(this.moment(start_date).isBefore(resv_date) && this.moment(end_date).isAfter(resv_date)) {
                has_discount = true;
              }
            }

            if(has_discount) {
              // 할인율 적용
              if(this.product.price.discount_type === 0) {
                discount_price = this.product.price.price * (this.product.price.discount_rate/100);
              }
              // 할인금액 적용
              else {
                discount_price = this.product.price.discount_price;
              }
            }
          }

        } else {
          discount_price = 0;
        }
        return discount_price;
      },
      essentialState() {
        if(this.option1 && this.option1.length>0) {
          return this.option1.every(item => item.value!==undefined)
        }
        else return false;
      },
      addState() {
        if(this.option2 && this.option2.length>0) {
          return this.option2.some(item => item.value!==undefined)
        }
        else return false;
      },
      isBtnEnable() {
        if (this.selectedResv === undefined || this.product.is_expired || !this.isOrderablePeriod) {
          return false;
        } else {
          return true;
        }
      },
      resvBtnOpacity() {
        let deco = {
          opacity: 1
        }
        if (this.selectedResv === undefined || this.product.is_expired || !this.isOrderablePeriod) {
          deco.opacity = 0.3;
        }
        return deco;
      },
      isOrderablePeriod() {
        if (this.selectedResv.days + 1 > this.product.maximum) {
          return false;
        } else {
          return true;
        }
      },
      computedSchedule() {
        if (this.selectedResv !== undefined) {
          if(this.$route.path.indexOf('/booking/order_create') > -1)
            return `${this.datesFormat(this.selectedResv.resv_date, 'date_3')} ~ ${this.datesFormat(this.selectedResv.resv_end_date, 'date_3')}`;
          else {
            if(this.selectedResv.all_time) {
              return `${this.selectedResv.org_start_date}`
            } else return `${this.selectedResv.org_start_date} ${this.selectedResv.start_time} ~ ${this.selectedResv.end_time}`
          }
        } else {
          return '날짜 선택';
        }
      },
      calendarBtnStyle() {
        let deco = {
          backgroundColor: '#ffffff',
          padding: '12px',
          borderRadius: '4px',
          border: '1px solid #ddd',
          marginBottom: '12px'
        }
        return deco;
      },
      selectedResvStyle() {
        let deco = {
        }
        if (this.selectedResv !== undefined) {
          deco.color = this.brandColor.main.color;
        }
        return deco;
      },
      containStyle() {
        return {
          backgroundColor: this.brandBgColor.sub.backgroundColor,
          borderRadius:"8px",
          height:"48px",
          width:"48px",
        }
      },
      closeStyle() {
        return {
          textAlign: 'center',
          fontSize: '16px'
        }
      },
      inquiryBtnStyle() {
        let deco = {
          height: '56px',
          padding: '0 24px',
          marginRight: '16px'
        };
        if (this.product.price.price_type !== 0 && this.product.inquiry_conversion_type > 0) {
          deco.marginRight = '0px';
        }
        return deco;
      },
      scheduleComponent() {
        return this.product.order_conversion_type === 10 ? 'ScheduleOverlay' : 'SchedulePeriodOverlay';
      },
    },
    watch: {

    }
  }
</script>


